export default __webpack_public_path__ + "static/N0222-a58190cb86c929d0946681e2eaaefeec.png";